import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import map from 'lodash/map';

import FieldLabel from './FieldLabel';
import { FONT_FAMILY_MAIN, LIGHT_BLUE_GREY, TEXT_COLOR } from '../../main-app/theme';
import arrowDown from '../../main-app/images/select-arrow.svg';
import media from '../../main-app/utils/mediaQueries';

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 3px;
`;

const SelectContainer = styled.label`
  display: block;
  position: relative;
  width: ${(props) => (props.width ? props.width : 'auto')};
  margin: 0;
  font-weight: inherit;
`;

const Select = styled.select`
  position: relative;
  height: 48px;
  width: 100%;
  padding: 0 40px 0 16px;
  border-radius: 2px;
  border: solid 1px rgba(0, 0, 0, 0.07);
  background-image: url(${arrowDown});
  background-repeat: no-repeat;
  background-size: 23px 23px;
  background-origin: border-box;
  background-position: right 6px top 13px;
  background-color: #f4f7f9;
  outline: none;
  font-size: ${(props) => props.fontSize ? props.fontSize : '14px'};
  font-weight: normal;
  line-height: 1.43;
  letter-spacing: 0.1px;
  color: ${(props) => props.value ? TEXT_COLOR : LIGHT_BLUE_GREY};
  transition: all .2s;
  font-family: ${FONT_FAMILY_MAIN};
  &::-ms-expand {
    display: none;
  }
  appearance: none;
  &:focus {
    border-color: #23c4f8 !important;
  }
  ${(props) => props.disabled
    ? `
    border: dashed 1px rgba(0, 0, 0, 0.07);
    color: #9aa1a9;
    &:hover {
      cursor: not-allowed;
    }
  `
    : `
    &:hover {
      border-color: rgba(41, 83, 102, 0.3);
    }
  `}
  ${(props) => props.valid === true
  && `
    border-color: #51e3ae !important;
  `}
  ${(props) => props.valid === false
  && `
    border-color: #f74656 !important;
    color: #f74656;
  `}

  ${(props) => props.icon && `
    padding-left: 42px;
  `}
  
  ${media.mobile`
    font-size: 16px;
    
    &:focus {
      font-size: 16px;
    }
  `}
`;

const Option = styled.option`
  color: ${TEXT_COLOR};
  
  &:disabled {
    color: ${LIGHT_BLUE_GREY};
  }
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  height: 20px;
  color: #f74656;
`;

const Image = styled.img`
  max-width: 30px;
  max-height: 30px;
  position: absolute;
  z-index: 1;
  top: 50%;
  left: 21px;
  transform: translate(-50%, -50%);
`;

class Combobox extends Component {
  constructor(props) {
    super(props);
    this.selectRef = React.createRef();
  }

  render() {
    const {
      label,
      placeholder,
      options,
      disabled,
      valid,
      optionalLink,
      optionalText,
      width,
      tabIndex,
      name,
      onChange,
      onBlur,
      value,
      errorMessage,
      icon,
      fontSize,
      'data-testid': dataTestId,
    } = this.props;

    return (
      <InputContainer>
        <FieldLabel
          label={label}
          optionalLink={optionalLink}
          optionalText={optionalText}
          valid={valid}
        />
        <SelectContainer width={width}>
          {icon && <Image src={icon} alt="dropdown icon" />}
          <Select
            width={width}
            tabIndex={tabIndex}
            placeholder={placeholder}
            disabled={disabled}
            valid={valid}
            name={name}
            onChange={onChange}
            onBlur={onBlur}
            value={value}
            data-test-selector={`form-field-${name}`}
            ref={this.selectRef}
            icon={icon}
            fontSize={fontSize}
            data-testid={dataTestId}
          >
            {placeholder && <Option label={placeholder} disabled />}
            {map(options, (item) => (
              <Option key={`index-${item.id}`} value={item.id}>
                {item.name}
              </Option>
            ))}
          </Select>
        </SelectContainer>
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </InputContainer>
    );
  }
}

Combobox.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  options: PropTypes.array,
  optionalLink: PropTypes.string,
  optionalText: PropTypes.string,
  disabled: PropTypes.bool,
  valid: PropTypes.bool,
  width: PropTypes.string,
  name: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  value: PropTypes.any,
  errorMessage: PropTypes.string,
  tabIndex: PropTypes.string,
  icon: PropTypes.string,
  fontSize: PropTypes.string,
  'data-testid': PropTypes.string,
};

Combobox.defaultProps = {
  label: '',
  placeholder: '',
  options: [],
  disabled: false,
  valid: null,
  width: null,
  optionalLink: '',
  optionalText: '',
  name: '',
  onChange: () => {
  },
  onBlur: () => {
  },
  value: '',
  errorMessage: '',
  tabIndex: null,
  icon: null,
  fontSize: '14px',
  'data-testid': '',
};

export default Combobox;
